import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=47a7ac54"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=47a7ac54&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports